import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import { typeViewBy } from '../../constant'
import classes from '../../index.module.scss'
import EachYear from './EachYear'
import Table from './Table'
import { selectLoading } from './store/slice'
import Trend from './trend'

const RoaAndRoe = ({ viewBy, id }) => {
  const loading = useSelector(selectLoading)

  return (
    <Element
      className={`h100 ${classes.containerPanel}`}
      style={{ color: '#3A414B' }}
    >
      {loading ? (
        <Loading />
      ) : viewBy === typeViewBy.TREND ? (
        <Trend id={id} />
      ) : viewBy === typeViewBy.EACH_YEAR ? (
        <EachYear id={id} />
      ) : (
        <Table id={id} />
      )}
    </Element>
  )
}

RoaAndRoe.propTypes = {
  viewBy: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}

export default RoaAndRoe
